import { takeEvery, put, call } from 'redux-saga/effects';
import { ACTION_TYPES } from 'src/constants';
import { createMandate, fetchMandate } from 'src/redux/api';
import { createMandateSuccess, createMandateFailure, fetchMandateSuccess, fetchMandateFailure } from 'src/redux/actions';

export function* watchMandateRequests() {
  yield takeEvery(ACTION_TYPES.REQUEST_CREATE_MANDATE, requestCreateMandate);
  yield takeEvery(ACTION_TYPES.FETCH_MANDATE_REQUEST, requestMandate);
}

function* requestCreateMandate(action) {
  try {
    const mandate = yield call(createMandate, action.payload);
    yield put(createMandateSuccess(mandate));
  } catch (e) {
    yield put(createMandateFailure(e));
  }
}


function* requestMandate(action) {
  try {
    const mandate = yield call(fetchMandate, action.payload);
    yield put(fetchMandateSuccess(mandate));
  } catch (e) {
    yield put(fetchMandateFailure(e));
  }
}